import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, TiposIndigenas } from './types';

export const INITIAL_STATE: TiposIndigenas = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): TiposIndigenas {
	return produce(state, draft => {
		switch (action.type) {
			case Types.TIPOS_INDIGENAS_REQUEST: {
				draft.status = 100;
				break;
			}
			case Types.TIPOS_INDIGENAS_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.TIPOS_INDIGENAS_FAILURE: {
				draft.status = action.payload.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
